import React from 'react';
import { cn } from "@/lib/utils";
import { TableColumn } from '../../agent-performance/tableConfig';
import { TableGridHeaderRow, TableGridHeaderCell, TABLE_HEADER_TITLE_CLASS } from "@/components/ui/table";

interface AgentMetricsTableHeaderRowProps {
  columns: TableColumn[];
}

export const AgentMetricsTableHeaderRow: React.FC<AgentMetricsTableHeaderRowProps> = ({ columns }) => {
  return (
    <TableGridHeaderRow className="text-xs font-medium text-primary dark:text-white sticky top-0 z-10">
      {columns.map((col, colIndex) => (
        <TableGridHeaderCell
          key={col.key}
          className={cn(
            "px-2 text-center transition-colors border-gray-300 dark:border-0 align-middle",
            "border-b dark:border-t border-gray-300 dark:border-0 font-bold",
            colIndex === 0 && "px-6"
          )}
          style={{
            minWidth: colIndex === 0 ? '200px' : col.minWidth,
            maxWidth: colIndex === 0 ? '265px' : col.maxWidth,
            width: colIndex === 0 ? '240px' : `calc((100% - 240px) / ${columns.length - 1})`
          }}
        >
          <div className={cn("text-left px-4 capitalize", TABLE_HEADER_TITLE_CLASS)}>
            {col.title}
          </div>
        </TableGridHeaderCell>
      ))}
    </TableGridHeaderRow>
  );
};